/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InternalApiRerunPeriodicScenarioForPeriodRequest
 */
export interface InternalApiRerunPeriodicScenarioForPeriodRequest {
    /**
     * 
     * @type {number}
     * @memberof InternalApiRerunPeriodicScenarioForPeriodRequest
     */
    scenarioId: number;
    /**
     * 
     * @type {Date}
     * @memberof InternalApiRerunPeriodicScenarioForPeriodRequest
     */
    from: Date;
    /**
     * 
     * @type {Date}
     * @memberof InternalApiRerunPeriodicScenarioForPeriodRequest
     */
    to: Date;
}

/**
 * Check if a given object implements the InternalApiRerunPeriodicScenarioForPeriodRequest interface.
 */
export function instanceOfInternalApiRerunPeriodicScenarioForPeriodRequest(value: object): value is InternalApiRerunPeriodicScenarioForPeriodRequest {
    if (!('scenarioId' in value) || value['scenarioId'] === undefined) return false;
    if (!('from' in value) || value['from'] === undefined) return false;
    if (!('to' in value) || value['to'] === undefined) return false;
    return true;
}

export function InternalApiRerunPeriodicScenarioForPeriodRequestFromJSON(json: any): InternalApiRerunPeriodicScenarioForPeriodRequest {
    return InternalApiRerunPeriodicScenarioForPeriodRequestFromJSONTyped(json, false);
}

export function InternalApiRerunPeriodicScenarioForPeriodRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiRerunPeriodicScenarioForPeriodRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'scenarioId': json['scenarioId'],
        'from': (new Date(json['from'])),
        'to': (new Date(json['to'])),
    };
}

export function InternalApiRerunPeriodicScenarioForPeriodRequestToJSON(json: any): InternalApiRerunPeriodicScenarioForPeriodRequest {
    return InternalApiRerunPeriodicScenarioForPeriodRequestToJSONTyped(json, false);
}

export function InternalApiRerunPeriodicScenarioForPeriodRequestToJSONTyped(value?: InternalApiRerunPeriodicScenarioForPeriodRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'scenarioId': value['scenarioId'],
        'from': value['from'].toISOString(),
        'to': value['to'].toISOString(),
    };
}

